import { Disciplines } from "@/components/disciplines";
import { createFileRoute } from "@tanstack/react-router";
import { ScrollableContainer } from "@/components/ui/scrollbar";
import { MobilePageTitle } from "@/components/ui/mobile-page-title";
import { useTranslation } from "react-i18next";

export const Route = createFileRoute("/(protected)/logistic/disciplines/")({
  component: RouteComponent,
});

function RouteComponent() {
  const { t } = useTranslation();

  return (
    <ScrollableContainer>
      <div className="flex h-full flex-col">
        <MobilePageTitle className="mt-6 mb-4">
          {t("pages:dashboard.sidebar.disciplines")}
        </MobilePageTitle>
        <Disciplines />
      </div>
    </ScrollableContainer>
  );
}
